import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

export default class ProgressGuestsModel extends BaseAPIModel {
    // Allow us to call getAll directly
    static list(item) {
        return item;
    }

    static listUrl({ organizationId, partnerId }) {
        if (!organizationId || !partnerId) {
            throw new ArgumentError(`[Model][ProgressGuestsModel][getAll] organizationId and partnerId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/partners/${partnerId}/guests/progress`;
    }
}
